import { IEscapeAllTagsInsideOptions } from './escapeAllTagsInside.types';
import { getRanges } from './utils/getRanges/getRanges';
import { removePositionsInRanges } from './utils/removePositionsInRanges/removePositionsInRanges';

export const escapeAllTagsInside = ({
  symbolsPositions,
  tag,
  ignoreTags,
}: IEscapeAllTagsInsideOptions): void => {
  const positions = symbolsPositions[tag];
  const ranges = tag === '@' ? positions : getRanges(positions);

  if (ranges.length === 0) {
    return;
  }

  const tags = Object.keys(symbolsPositions).filter((item) => !ignoreTags.includes(item));

  for (let i = 0; i < tags.length; i++) {
    const tag = tags[i];

    symbolsPositions[tag] = removePositionsInRanges({
      positions: symbolsPositions[tag],
      ranges,
    });
  }
};
